<template>
  <div>
    <common-dialog ref="dialog" width="500px" title="排入" id-key="UserId" :data="data" @edit-opened="opened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label-width="16px">
              <el-radio-group v-model="data.SchedulingModel">
                <el-radio :label="0">时间排产</el-radio>
                <el-radio :label="1">插单排产</el-radio>
                <el-radio :label="2">顺延排产</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="15">
          <el-col>
            <el-form-item v-show="data.SchedulingModel === 0" label="开工时间">
              <el-date-picker v-model="data.StartDate" type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions"> </el-date-picker>
            </el-form-item>

            <el-form-item label="工单号" v-show="data.SchedulingModel === 1">
              <el-select v-model="data.WorkDocNo" filterable>
                <el-option v-for="item in workDocs" :key="item.WorkDocId" :label="item.WorkDocNo" :value="item.WorkDocNo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      api: require('@/api/pu/plan').default,
      data: {
        WorkDocId: 0,
        SchedulingType: 1,
        SchedulingModel: 2,
        StartDate: '',
        WorkDocNo: ''
      },
      workDocs: [],
      time: '',
      order: '',
      timeList: [],
      schedulingDates: [],
      pickerOptions: {
        disabledDate: time => {
          let bool = false

          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let day = time.getDate()

          //console.log('selectableRange', this.pickerOptions.selectableRange,this.schedulingDates)

          let t = `${year}/${month}/${day}`
          let index = this.schedulingDates.indexOf(t)
          if (index === -1) {
            bool = true
          }
          //console.log(t,index,"t");

          return bool
        }
      }
    }
  },
  created() {
    this.api.schedulingDateRange({ SchedulingType: 1 }).then(res => {
      if (res.Code === 0) {
        this.timeList = res.Data
        this.schedulingDates = this.timeList.map(item => {
          return item.SchedulingDate
        })

        console.log(this.timeList, 'this.timeList3 ')
        if (this.timeList.length > 0) {
          console.log(this.timeList, 'this.timeList ')
          this.pickerOptions.selectableRange = `${this.timeList[0].SchedulingTimeRanges[0].SchedulingStartTime}:00 - ${this.timeList[0].SchedulingTimeRanges[0].SchedulingEndtTime}:00`
        }
      }
    })
  },
  methods: {
    save() {
      var loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .schedulingSave(this.data)
        .then(res => {
          if (res.Code === 0) {
            console.log('res.Data', res.Data)
            this.$message({ type: 'success', message: res.Msg })
            this.$emit('changeDrain', this.data)
            loading.close()
            this.close(true)
          } else {
            this.$message({ type: 'warning', message: res.Msg })
            loading.close()
          }
        })
        .catch(err => {
          console.error(err)
          loading.close()
        })
    },
    opened(row) {
      console.log('row', row)
      this.data.WorkDocId = row.WorkDocId
      this.data.SchedulingType = row.SchedulingType ?? 1
      this.data.SchedulingModel = row.SchedulingModel ?? 2
      this.data.StartDate = row.StartDate ?? ''
      this.data.PrPlanDtsList=row.PlanDts;
    },
    closeDialog() {
      this.close(true)
    }
  }
}
</script>
